import fetch from '../../api/fetch'

import {
    FETCH_POLICY_CATEGORIES_TRIGGER,
    FETCH_POLICY_TYPES_TRIGGER,
    FETCH_COUNTRIES_TRIGGER,
} from '../../constants/quote/step00'

/**
 *     Action to fetch policy types
 *
 *  @param  {string} URL [/api/v1/policy_types]
 *     @method GET
 */
// export function fetchPolicyType () {
//     return {
//         type    : 'GET_POLICYTYPE',
//         payload : fetch(`/policy_types`, { method: 'GET' }),
//     }
// }

export const fetchPolicyCategories = () => ({
    type: FETCH_POLICY_CATEGORIES_TRIGGER,
    payload: fetch('/policy_categories', { method: 'GET' }),
})

export const fetchPolicyTypes = () => ({
    type: FETCH_POLICY_TYPES_TRIGGER,
    payload: fetch('/policy_types', { method: 'GET' }),
})

export const fetchCountries = () => ({
    type: FETCH_COUNTRIES_TRIGGER,
})

export function fetchOccupancies(occupancyType: any = 'Commercial occupancy', search: any = '', sortOrder: any = '') {
    return {
        type: 'FETCH_OCCUPANCIES',
        payload: fetch(
            `/occupancies?occupancy_type=${occupancyType}&search=${search}&sort_order=${sortOrder}`,
            { method: 'GET' }
        ),
    }
}

/**
 * 	Action to post data for step00
 *
 *  @param  {object} content [Body to be sent with step00 content]
 *  @param  {string} URL [/quotes/step00]
 * 	@method POST
 */
export function setStep00 (content: object) {
    return {
        type    : 'SET_STEP00',
        payload : fetch(`/quotes/step00`, { method: 'POST', body: content }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/step00.ts